module.exports = __webpack_public_path__ + "img/Group1.ff39410d.svg";